import './MatchNotification.less';

import React, { FC, useContext } from 'react';
import TurboLiveContext from '../../context/TurboLiveContext';
import { SvgIcon } from '../../../../icons/SvgIcon';
import clsx from 'clsx';
import { isMobileChannel } from '../../../../common/util';

export const MatchNotification: FC<{ matchId: string; sportId: string }> = ({ matchId, sportId }) => {
    const { MatchNotificationBox } = useContext(TurboLiveContext);
    const [supported, subscribed, notificationTypes, onClick] = MatchNotificationBox(matchId, sportId);

    if (!supported || !notificationTypes || !notificationTypes.length) {
        return null;
    }
    const isMobileView = isMobileChannel();
    const iconSize = isMobileView ? '16' : '14';
    return (
        <button
            onClick={onClick}
            className={clsx(
                'match-notification bg-white-ng br-radius-circle fs-0 mx-10',
                `${isMobileView ? 'my-10 py-10 px-10' : 'my-7 py-8 px-8'}`,
                subscribed && 'active'
            )}
        >
            <SvgIcon imgId="live-notify" sizeX={iconSize} sizeY={iconSize} className="c-black-50" />
        </button>
    );
};
